// extracted by mini-css-extract-plugin
export default {"heroVideo":"homepage-homepage-hero-HeroVideo__heroVideo--1Gz3j"};